<template>
  <div>
    <div class="text-h1 mb-4">{{ content.title }}</div>
    <div class="legal-document" v-html="content.content"></div>
  </div>
</template>

<script>
import profileDocuments from '@/mixins/profileDocuments';
import legalDocuments from '@/mixins/legalDocuments';

export default {
  name: 'DocumentMobile',
  mixins: [profileDocuments, legalDocuments],
  data() {
    return {
      content: {
        content: '',
        title: ''
      }
    };
  },
  async mounted() {
    let requestedDocument = this.profileLegalDocuments.find(
      document => document.documentName === this.$route.query.documentName
    );
    this.content = await this.getLegalDocument(
      requestedDocument.category,
      requestedDocument.typeName
    );
  }
};
</script>
